import StyledButtonIcon from './StyledButtonIcon';

type ButtonIconProps = {
  label: string;
  icon: React.ElementType;
  onClick: () => void;
  position?: string;
  right?: string;
  top?: string;
  transform?: string;
};

const ButtonIcon = ({
  label,
  icon: IconComponent,
  onClick,
  position = 'static',
  top,
  right,
  transform = 'none',
}: ButtonIconProps): JSX.Element => {
  return (
    <StyledButtonIcon
      variant="text"
      onClick={onClick}
      position={position}
      top={top}
      right={right}
      transform={transform}
    >
      <>
        {label}
        <IconComponent />
      </>
    </StyledButtonIcon>
  );
};

export default ButtonIcon;
